var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "risk-assessment scroll-form",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()) + "\n      ")]), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'A',
      "title": _vm.$vuetify.t('$vuetify.powra.siteAndTaskDetails')
    }
  }), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold no-bottom-border"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.powra.jobNo')) + "\n          ")])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-text', {
    staticClass: "no-bottom-border"
  }, [_vm._v("\n            " + _vm._s(_vm.callDetail.call_remote_id) + "\n          ")])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold no-bottom-border"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.powra.client')) + "\n          ")])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-text', {
    staticClass: "no-bottom-border"
  }, [_vm._v("\n            " + _vm._s(_vm.callDetail.company) + "\n          ")])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold no-bottom-border"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.powra.siteAddress')) + "\n          ")])], 1), _c('v-flex', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-text', {
    staticClass: "no-bottom-border"
  }, [_vm.callDetail.address_line_1 ? _c('span', [_vm._v(_vm._s(_vm.callDetail.address_line_1))]) : _vm._e(), _vm.callDetail.address_line_2 ? _c('span', [_vm._v(", " + _vm._s(_vm.callDetail.address_line_2))]) : _vm._e(), _vm.callDetail.address_line_3 ? _c('span', [_vm._v(", " + _vm._s(_vm.callDetail.address_line_3))]) : _vm._e(), _vm._v("\n             \n          ")])], 1), _c('v-flex', {
    staticClass: "border",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": _vm.$vuetify.t('$vuetify.powra.taskDetails'),
      "auto-grow": ""
    },
    model: {
      value: _vm.taskDetails,
      callback: function callback($$v) {
        _vm.taskDetails = $$v;
      },
      expression: "taskDetails"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n          ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted();
      }
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }